import React from 'react';
import { isMobile } from 'react-device-detect';
import { Panel } from '../../common-components/Layout/Panel/Panel';

interface IFormProps {
    width?: string;
}

export const FormLogin: React.FC<IFormProps> = ({
    children,
    width
}) => {

    const [dimensions, setDimensions] = React.useState({ 
        height: window.innerHeight,
        width: window.innerWidth
    });

    React.useEffect(() => {
        function handleResize() {
          setTimeout(() => setDimensions({
            height: window.innerHeight,
            width: window.innerWidth
          }), 100);
        };
    
        window.addEventListener('resize', handleResize);
    
        return () => {
          window.removeEventListener('resize', handleResize);
        }
    }, []);

    const memoWidth = React.useMemo(() => {
        if (isMobile) return '95%';
        if (dimensions.width > 1400) return '40%';
        if (dimensions.width > 1100) return '50%';
        if (dimensions.width > 950) return '55%';
        if (dimensions.width > 700) return '70%';
        return `95%`;
    }, [dimensions]);

    return (
        <Panel
            marginLeft='auto'
            marginRight='auto'
            width={width || memoWidth}
        >{children}</Panel>
    );
}